import React, { useState, useEffect} from "react";
import { Helmet } from "react-helmet-async";
import { useParams } from 'react-router-dom';
import { config } from '../../config/env';
import Layout from "../../components/layout/Layout"
import ResearchHeader from "../../components/researchheader/ResearchHeader";
import VideoComponent from "../../components/video/Video";
import Loader from "../../components/modal/Loader";

const DemoById = () => {
  const { id } = useParams();

  const [demoData, setDemoData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
  
    useEffect(() => {
      const fetchDemoById = async () => {
        setIsLoading(true);
        try {
          const response = await fetch(`${config.apiBaseUrl}/api/v1/content/demos/${id}`, {
            method: 'GET',
            headers: {
              "Content-Type": "application/json",
            }
          });
  
          if (!response.ok) {
            throw new Error('Failed to fetch demo');
          }
  
          const data = await response.json();
          setDemoData(data);
        }
        catch (error) {
          console.error('Error fetching demo:', error);
        }
        finally {
          setIsLoading(false);
        }
      };
  
      if (id) {
        fetchDemoById();
      }
    }, [id]);
  
  return (
    <div>
      <Helmet>
        <title>Avanade Research</title>
      </Helmet>
      <Layout>
            <ResearchHeader
              type={demoData?.topic?.name || ""}
              title={demoData?.title || ""}
              date={demoData ? new Date(demoData.created_at).toLocaleDateString() : ""}
              author={demoData?.author || ""}
            /> 
            <VideoComponent 
              videoSrc={demoData?.video_url} 
              description={demoData?.description || "No description available."}
            />
      </Layout>
      {isLoading && <Loader />}
    </div>
  );
};

export default DemoById;
